import Action from 'lib/interfaces/Action';

interface EditorPayload {
  locale?: string;
  selectedTemplateId?: string;
}

export type EditorActions =
  | Action<EditorActionType.SetLocale, EditorPayload>
  | Action<EditorActionType.SetSelectedTemplateId, EditorPayload>;

export enum EditorActionType {
  SetLocale = 'editor/SET_LOCALE',
  SetSelectedTemplateId = 'editor/SET_SELECTED_TEMPLATE_ID',
}

export function setLocale(locale: string) {
  return {
    payload: {
      locale,
    },
    type: EditorActionType.SetLocale,
  };
}

export function setSelectedTemplateId(selectedTemplateId: string) {
  return {
    payload: {
      selectedTemplateId,
    },
    type: EditorActionType.SetSelectedTemplateId,
  };
}
